import React, { FC } from "react";
import { useParams } from "react-router-dom";
import { LocalizeText } from "components/localizer";
import Banner from "components/banner";
import { usePaginationStore } from "utils/usePaginationStore";
import { StaffSubscriptionsTable } from "components/tableComponents/staffSubscriptionsTable";
import TopBar from "components/tableComponents/topBar";
import SubscriptionFilterInput from "components/searchFilterComponents/subscriptionFilter";
import SearchFilterField from "components/searchFilterField";

const StaffSubscriptionsView: FC = () => {
    const { communityId } = useParams<{ communityId: string }>();

    const pagination = usePaginationStore("subscriptions", undefined, {
        active: true,
        community_id: communityId,
        page_size: 20,
        default_page_size: 20,
        search_by: "staff",
    });

    return (
        <div className="contentWrapper">
            <Banner
                title="subscriptions"
                subTitle="bannerStaffSubscriptions"
                imageStyle={{ objectPosition: "70% 30%" }}
                image={`${process.env.PUBLIC_URL}/assets/images/arenaStaff/subscriptions.jpg`}
            />
            <TopBar
                searchField={
                    <SearchFilterField
                        pagination={pagination}
                        label={<LocalizeText tag="searchSubscriptions" />}
                        filterFields={<SubscriptionFilterInput subscriptionPagination={pagination} />}
                    />
                }
            />

            <StaffSubscriptionsTable pagination={pagination} loading={pagination.query.isFetching} />
        </div>
    );
};
export default StaffSubscriptionsView;
